import { ApiProperty } from "@nestjs/swagger";

export class BomIdRequest{
    @ApiProperty()
    packingMaterialId:number;
    @ApiProperty()
    isActive?:boolean;
    @ApiProperty()
    poQty?:number;
    @ApiProperty()
    fromPo?:boolean;
    @ApiProperty()
    itemId?:number;
}
